import React, { useState, useEffect, useRef } from "react";
import styles from "./style.module.scss";
import { UNLOGGED } from "util/constants";
import { useHistory } from "react-router-dom";
import "./chartsStyle.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTv, faBell, faUsers } from "@fortawesome/free-solid-svg-icons";
import { DownOutlined } from "@ant-design/icons";
import KpiViewBoard from "./KpiView/KpiViewBoard";
import { apiRequest } from "util/services";
import ShareButtonPopup from "helperComponents/ShareButtonPopup";
import ConsolePageHeader, {
  ConsolePageHeaderActionPrimary,
  ConsolePageHeaderActionSecondary,
  ConsolePageHeaderActionOverflow,
  consolePageHeaderStyles,
} from "components/ConsolePageHeader";
import { Select, notification, Radio, Tooltip, Spin, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import {
  toKpiApiPeriod,
} from "./KpiView/kpiViewUtils";
const { Option } = Select;

const GlobalExecutiveDashboard = ({ authenticated, user, match, theme }) => {
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [selectedTeamItem, setSelectedTeamItem] = useState("");
  const [selectedTeamName, setSelectedTeamName] = useState("");
  const [teamList, setTeamList] = useState([]);
  const [shareList, setShareList] = useState([]);
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [presentationTitle, setPresentationTitle] = useState(() =>
    t("team_kpi_view.presentation_title", "Global Executive Dashboard")
  );
  const [showTitlePopup, setShowTitlePopup] = useState(false);
  const [showDataLabel, setShowDataLabel] = useState(false);

  const [kpiCompareWindow, setKpiCompareWindow] = useState("30D");
  const [, setSettingsLoading] = useState(false);

  const [allowShare, setAllowShare] = useState(true);
  const [dataLoading, setDataLoading] = useState(false);
  const [presentationType, setPresentationType] = useState("trend");
  const [focusKpiId, setFocusKpiId] = useState(null);
  const deepLinkRef = useRef({ team: null, kpi: null });

  useEffect(() => {
    setPresentationTitle((prev) => {
      if (
        prev === "Global Executive Dashboard" ||
        prev === "Global Yönetici Panosu"
      ) {
        return t("team_kpi_view.presentation_title", "Global Executive Dashboard");
      }
      return prev;
    });
  }, [i18n.language, t]);

  useEffect(() => {
    if (!selectedTeamItem) return;
    try {
      sessionStorage.setItem("copilotKpiTeamId", String(selectedTeamItem));
    } catch (_) {}
  }, [selectedTeamItem]);

  if (authenticated === UNLOGGED) {
    history.push("/");
  }

  const handlePresentationMode = () => {
    setShowTitlePopup(true);
  };

  const handleOpenShare = () => {
    if (shareList.length === 0) {
      notification.error({
        message: t("notifications.49"),
      });
      return;
    }
    setShowSharePopup(true);
  };

  const gotoPresentation = () => {
    if (presentationType === "trend") {
      const open = window.open(
        `/global_executive/presentation/?id=${selectedTeamItem}&period=${toKpiApiPeriod(kpiCompareWindow)}`,
        "_blank"
      );
      open.title = presentationTitle;
      open.showDataLabel = showDataLabel;
      setShowTitlePopup(false);
      setPresentationTitle("");
    } else {
      const open = window.open(
        `/global_executive/reviews?id=${selectedTeamItem}&period=${toKpiApiPeriod(kpiCompareWindow)}&review=${true}`,
        "_blank"
      );
      open.title = presentationTitle;
      open.showDataLabel = showDataLabel;
      setShowTitlePopup(false);
      setPresentationTitle("");
    }
  };

  const handleTeamFilter = (value) => {
    setDataLoading(true);
    setSelectedTeamName(value);
    for (let i = 0; i < teamList?.length; i++) {
      if (value === teamList[i].team_name) {
        setSelectedTeamItem(teamList[i].team_id);
        setAllowShare(teamList[i].owned);
      }
    }
  };

  const getCollaborators = async () => {
    await getSettingsData();
    const result = await apiRequest(
      "executive_summary/kpi_views",
      "POST",
      true
    );
    if (result.success) {
      setTeamList(result?.success);
      setSelectedTeamItem(result?.success[0]?.team_id);
      setSelectedTeamName(result?.success[0]?.team_name);
      setAllowShare(result?.success[0]?.owned);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    deepLinkRef.current = {
      team: params.get("team"),
      kpi: params.get("kpi"),
    };
    getCollaborators();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!teamList.length) return;
    const { team, kpi } = deepLinkRef.current;
    if (team) {
      const match = teamList.find(
        (item) => String(item.team_id) === String(team)
      );
      if (match) {
        setSelectedTeamItem(match.team_id);
        setSelectedTeamName(match.team_name);
        setAllowShare(match.owned);
      }
    }
    if (kpi) {
      setFocusKpiId(String(kpi));
    }
  }, [teamList]);

  const getTeams = async () => {
    const payload = {
      team_id: selectedTeamItem,
    };
    const result = await apiRequest(
      "executive_summary/teams",
      "POST",
      payload,
      true
    );
    if (result.success) {
      setShareList(result?.success);
    }
  };

  const handleShareTeam = async (selectedItems) => {
    const payload = {
      shared_with: selectedItems,
      team_id: selectedTeamItem,
    };
    const result = await apiRequest(
      "executive_summary/share",
      "POST",
      payload,
      true
    );
    if (result.success) {
      notification.success({
        message: t("notifications.20"),
      });
      setShowSharePopup(false);
      getTeams();
    }
    if (result.error) {
      notification.error({
        message: result.error,
      });
    }
  };

  const getSettingsData = async () => {
    setSettingsLoading(true);
    let payload = {};
    const result = await apiRequest(
      "executive_summary/settings",
      "POST",
      payload,
      true
    );
    if (result?.success) {
      if (result.success?.showNumbers) {
        setShowDataLabel(true);
      }
    }
    setSettingsLoading(false);
  };

  useEffect(() => {
    if (selectedTeamItem) getTeams();
  }, [selectedTeamItem]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={`mainWindow ${
        theme === "light" ? "light-mode" : theme === "brand" ? "brand-mode" : ""
      }`}
    >
      <ConsolePageHeader
        title={t("dashboard_sidebar.2")}
        titleColor={theme === "dark" ? "#fff" : "#000"}
        breadcrumb={
          <Select
            value={selectedTeamName}
            onChange={handleTeamFilter}
            disabled={dataLoading}
            showSearch
            variant="borderless"
            popupMatchSelectWidth={false}
            optionFilterProp="title"
          >
            {teamList?.map((item) => (
              <Option
                value={item.team_name}
                key={item.team_id}
                title={item.team_name}
              >
                {item.team_name}
              </Option>
            ))}
          </Select>
        }
        actions={
          <>
            <div className={consolePageHeaderStyles.secondaryGroup}>
              <div
                className={`${consolePageHeaderStyles.periodToggle} ${
                  dataLoading ? consolePageHeaderStyles.periodToggleBusy : ""
                }`}
                role="group"
                aria-busy={dataLoading}
                aria-label={t(
                  "team_kpi_view.window_group_label",
                  "See trend in 7-day or 30-day intervals",
                )}
              >
                <span className={consolePageHeaderStyles.periodToggleLabel}>
                  {t("team_kpi_view.window_label", "See trend")}
                </span>
                <div className={consolePageHeaderStyles.periodToggleGroup}>
                  <button
                    type="button"
                    className={`${consolePageHeaderStyles.periodToggleBtn} ${
                      kpiCompareWindow === "7D"
                        ? consolePageHeaderStyles.periodToggleBtnActive
                        : ""
                    }`}
                    aria-pressed={kpiCompareWindow === "7D"}
                    onClick={() => setKpiCompareWindow("7D")}
                  >
                    {t("team_kpi_view.window_7", "7 days")}
                  </button>
                  <button
                    type="button"
                    className={`${consolePageHeaderStyles.periodToggleBtn} ${
                      kpiCompareWindow === "30D"
                        ? consolePageHeaderStyles.periodToggleBtnActive
                        : ""
                    }`}
                    aria-pressed={kpiCompareWindow === "30D"}
                    onClick={() => setKpiCompareWindow("30D")}
                  >
                    {t("team_kpi_view.window_30", "30 days")}
                  </button>
                </div>
                <span
                  className={consolePageHeaderStyles.periodToggleStatus}
                  aria-hidden={!dataLoading}
                >
                  {dataLoading ? <Spin size="small" /> : null}
                </span>
              </div>
              <Tooltip
                title={t(
                  "team_kpi_view.viewAlertsTooltip",
                  "Tüm KPI alarmlarını yönet — kart üzerindeki zil ile tek KPI uyarısı kurulur"
                )}
              >
                <ConsolePageHeaderActionSecondary
                  onClick={() => history.push("/console/alerts")}
                >
                  <FontAwesomeIcon icon={faBell} />
                  <span>{t("team_kpi_view.viewAlerts")}</span>
                </ConsolePageHeaderActionSecondary>
              </Tooltip>
              {allowShare ? (
                <Dropdown
                  trigger={["click"]}
                  placement="bottomRight"
                  overlayClassName={consolePageHeaderStyles.overflowMenu}
                  menu={{
                    items: [
                      {
                        key: "share",
                        icon: <FontAwesomeIcon icon={faUsers} />,
                        label: t("team_kpi_view.1"),
                        onClick: handleOpenShare,
                      },
                      {
                        key: "present",
                        icon: <FontAwesomeIcon icon={faTv} />,
                        label: t("team_kpi_view.2"),
                        disabled: Boolean(dataLoading),
                        onClick: handlePresentationMode,
                      },
                    ],
                  }}
                >
                  <ConsolePageHeaderActionOverflow
                    aria-label={t("team_kpi_view.more_actions", "More")}
                    aria-haspopup="menu"
                  >
                    <span>{t("team_kpi_view.more_actions", "More")}</span>
                    <DownOutlined />
                  </ConsolePageHeaderActionOverflow>
                </Dropdown>
              ) : (
                <ConsolePageHeaderActionPrimary
                  disabled={Boolean(dataLoading)}
                  onClick={handlePresentationMode}
                >
                  <FontAwesomeIcon icon={faTv} />
                  <span>{t("team_kpi_view.2")}</span>
                </ConsolePageHeaderActionPrimary>
              )}
            </div>
          </>
        }
      />

      {allowShare ? (
        <ShareButtonPopup
          hideTrigger
          setShowSharePopup={setShowSharePopup}
          showSharePopup={showSharePopup}
          headingText={t("others.10")}
          handleShare={handleShareTeam}
          shareList={shareList}
          marginRight="0"
        />
      ) : null}

      {selectedTeamItem && (
        <KpiViewBoard
          selectedTeamItem={selectedTeamItem}
          teamList={teamList}
          chartPeriod={toKpiApiPeriod(kpiCompareWindow)}
          setDataLoading={setDataLoading}
          readOnly={!allowShare}
          focusKpiId={focusKpiId}
        />
      )}

      {showTitlePopup && (
        <div
          className={styles.presentationTitleModal}
          onClick={() => setShowTitlePopup(false)}
        >
          <div className={styles.centerWrapper}>
            <div
              className={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <p>{t("team_kpi_view.3")}</p>
              <input
                type="text"
                value={presentationTitle}
                onChange={(e) => setPresentationTitle(e.target.value)}
              />
              <Radio.Group
                value={presentationType}
                className={styles.viewTypeWrapper}
                onChange={(e) => {
                  setPresentationType(e.target.value);
                }}
              >
                <Radio value="trend">
                  <span className={styles.fontColor}>
                    {t("team_kpi_view.37")}
                  </span>
                </Radio>
                <Radio value="reviews">
                  <span className={styles.fontColor}>
                    {t("team_kpi_view.38")}
                  </span>
                </Radio>
              </Radio.Group>
              <div className={styles.proceedBtn}>
                <button onClick={gotoPresentation}>{t("button.6")}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GlobalExecutiveDashboard;
